//what-is-new
export const START_WHAT_IS_NEW = "START_WHAT_IS_NEW";
export const WHAT_IS_NEW_SUCCESS = "WHAT_IS_NEW_SUCCESS";
export const WHAT_IS_NEW_FAILED = "WHAT_IS_NEW_FAILED";
